import { OfficeHoursService } from "../../../services/OfficeHoursService"
import { useEffect, useMemo, useState } from "react";
import TimePicker from "../../../components/form-controls/TimePicker";
import Button from "../../../components/form-controls/Button";
import { AlertService } from "../../../services/Alert";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { useTranslation } from "react-i18next";
import useRequest from "../../../hooks/useRequest";
import Loader from "../../../components/Loader";
function OfficeHoursPartial() {

    const { t } = useTranslation();
    const { account } = useCurrentAccount();
    const { call, isRequesting } = useRequest();
    const [settings, setSettings] = useState({
        id: 0,
        account_id: 0,
        limited_connection: 0,
        limited_asignation: 0,
        automatic_messages: 0,
        Monday_start: '',
        Monday_end: '',
        Monday_status: false,
        Tuesday_start: '',
        Tuesday_end: '',
        Tuesday_status: false,
        Wednesday_start: '',
        Wednesday_end: '',
        Wednesday_status: false,
        Thursday_start: '',
        Thursday_end: '',
        Thursday_status: false,
        Friday_start: '',
        Friday_end: '',
        Friday_status: false,
        Saturday_start: '',
        Saturday_end: '',
        Saturday_status: false,
        Sunday_start: '',
        Sunday_end: '',
        Sunday_status: false,
    })

    const getSettings = async () => {
        let { data } = await call(() => OfficeHoursService.getSettings(account.id));

        data = {
            ...data,
            Monday_status: !(data.Monday_start === '00:00:00' && data.Monday_start === data.Monday_end),
            Tuesday_status: !(data.Tuesday_start === '00:00:00' && data.Tuesday_start === data.Tuesday_end),
            Wednesday_status: !(data.Wednesday_start === '00:00:00' && data.Wednesday_start === data.Wednesday_end),
            Thursday_status: !(data.Thursday_start === '00:00:00' && data.Thursday_start === data.Thursday_end),
            Friday_status: !(data.Friday_start === '00:00:00' && data.Friday_start === data.Friday_end),
            Saturday_status: !(data.Saturday_start === '00:00:00' && data.Saturday_start === data.Saturday_end),
            Sunday_status: !(data.Sunday_start === '00:00:00' && data.Sunday_start === data.Sunday_end),
        }

        setSettings(data)
    }

    const handleDayOff = (key: string, value: boolean) => {
        if (!value) {
            const day = key.split('_')[0];

            setSettings({ ...settings, [`${day}_start`]: '00:00:00', [`${day}_end`]: '00:00:00', [key]: value })
        } else {
            setSettings({ ...settings, [key]: value })
        }

    }

    const saveHours = async () => {
        const isConfirmed = await AlertService.warning('Guardar horarios laboral', `¿Estás seguro de querer actualizar los horarios laborales?`, async () => {
            try {

                await OfficeHoursService.updateOfficeHours(settings)
                await getSettings()
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', 'Ocurrió un error al guardar los horarios laborales, intenta nuevamente')
            }
        });

        if (isConfirmed) {
            AlertService.success('¡Éxito!', 'Se guardó la información correctamente', 'Ok');
        }
    }

    const saveSettingsSession = async (key: string) => {
        const isConfirmed = await AlertService.warning('¡Aviso!', `¿Estás seguro de querer ${settings.limited_connection ? 'activar' : 'desactivar'} esta opción?`, async () => {
            try {

                const field = settings[key];


                await OfficeHoursService.updateSettings({ ...settings, [key]: field ? 0 : 1 })
                await getSettings()
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', 'Ocurrió un error al guardar la configuración, intenta nuevamente')
            }
        });

        if (isConfirmed) {
            AlertService.success('¡Éxito!', 'Se guardó la configuración correctamente', 'Ok');
        }
    }

    useEffect(() => {
        getSettings()
    }, [])
    const heightRequesting = useMemo(()=> {return isRequesting ? 'h-200':''},[isRequesting]);
    return (
        <>
            <div className="card">

                <div className="card-header d-flex align-items-center">
                    <div className="me-3">
                        <h2 className="card-title h4">  {t("config.operation-hours.operation-title")}</h2>
                        <p>{t("config.operation-hours.operation-p")}</p>
                    </div>

                </div>
                        <div className="card-body">
                            <div className={`relative ${heightRequesting}`}>
                            {
                                isRequesting ? <Loader /> :
                                <>
                                <div className="row">
                                    <div className="col">

                                        <div className="table-responsive">

                                            <table className="table">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th scope="col" style={{ width: '20%' }}>{t("config.operation-hours.day")}</th>
                                                        <th scope="col" style={{ width: '20%' }}>{t("config.operation-hours.status")}</th>
                                                        <th scope="col" style={{ width: '30%' }}>{t("config.operation-hours.opening-time")}</th>
                                                        <th scope="col" style={{ width: '30%' }}>{t("config.operation-hours.closure-time")}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>{t("config.operation-hours.monday")}</td>
                                                        <td>
                                                            <div className="form-check form-switch ">
                                                                <input type="checkbox" className="form-check-input" id="Monday_status" checked={settings.Monday_status} onChange={({ target: { checked } }) => handleDayOff('Monday_status', checked)} />
                                                                <label className="form-check-label" htmlFor="Monday_status">{t("config.operation-hours.operating-day")}</label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <TimePicker time={settings.Monday_start} onChange={(value) => setSettings({ ...settings, Monday_start: value })} disable={!settings.Monday_status} />
                                                        </td>
                                                        <td>
                                                            <TimePicker time={settings.Monday_end} onChange={(value) => setSettings({ ...settings, Monday_end: value })} disable={!settings.Monday_status} />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>{t("config.operation-hours.tuesday")}</td>
                                                        <td>
                                                            <div className="form-check form-switch ">
                                                                <input type="checkbox" className="form-check-input" id="Tuesday_status" checked={settings.Tuesday_status} onChange={({ target: { checked } }) => handleDayOff('Tuesday_status', checked)} />
                                                                <label className="form-check-label" htmlFor="Tuesday_status">{t("config.operation-hours.operating-day")}</label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <TimePicker time={settings.Tuesday_start} onChange={(value) => setSettings({ ...settings, Tuesday_start: value })} disable={!settings.Tuesday_status} />
                                                        </td>
                                                        <td>
                                                            <TimePicker time={settings.Tuesday_end} onChange={(value) => setSettings({ ...settings, Tuesday_end: value })} disable={!settings.Tuesday_status} />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>{t("config.operation-hours.wednesday")}</td>
                                                        <td>
                                                            <div className="form-check form-switch ">
                                                                <input type="checkbox" className="form-check-input" id="Wednesday_status" checked={settings.Wednesday_status} onChange={({ target: { checked } }) => handleDayOff('Wednesday_status', checked)} />
                                                                <label className="form-check-label" htmlFor="Wednesday_status">{t("config.operation-hours.operating-day")}</label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <TimePicker time={settings.Wednesday_start} onChange={(value) => setSettings({ ...settings, Wednesday_start: value })} disable={!settings.Wednesday_status} />
                                                        </td>
                                                        <td>
                                                            <TimePicker time={settings.Wednesday_end} onChange={(value) => setSettings({ ...settings, Wednesday_end: value })} disable={!settings.Wednesday_status} />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>{t("config.operation-hours.thursday")}</td>
                                                        <td>
                                                            <div className="form-check form-switch ">
                                                                <input type="checkbox" className="form-check-input" id="Thursday_status" checked={settings.Thursday_status} onChange={({ target: { checked } }) => handleDayOff('Thursday_status', checked)} />
                                                                <label className="form-check-label" htmlFor="Thursday_status">{t("config.operation-hours.operating-day")}</label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <TimePicker time={settings.Thursday_start} onChange={(value) => setSettings({ ...settings, Thursday_start: value })} disable={!settings.Thursday_status} />
                                                        </td>
                                                        <td>
                                                            <TimePicker time={settings.Thursday_end} onChange={(value) => setSettings({ ...settings, Thursday_end: value })} disable={!settings.Thursday_status} />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>{t("config.operation-hours.friday")}</td>
                                                        <td>
                                                            <div className="form-check form-switch ">
                                                                <input type="checkbox" className="form-check-input" id="Friday_status" checked={settings.Friday_status} onChange={({ target: { checked } }) => handleDayOff('Friday_status', checked)} />
                                                                <label className="form-check-label" htmlFor="Friday_status">{t("config.operation-hours.operating-day")}</label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <TimePicker time={settings.Friday_start} onChange={(value) => setSettings({ ...settings, Friday_start: value })} disable={!settings.Friday_status} />
                                                        </td>
                                                        <td>
                                                            <TimePicker time={settings.Friday_end} onChange={(value) => setSettings({ ...settings, Friday_end: value })} disable={!settings.Friday_status} />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>{t("config.operation-hours.saturday")}</td>
                                                        <td>
                                                            <div className="form-check form-switch ">
                                                                <input type="checkbox" className="form-check-input" id="Saturday_status" checked={settings.Saturday_status} onChange={({ target: { checked } }) => handleDayOff('Saturday_status', checked)} />
                                                                <label className="form-check-label" htmlFor="Saturday_status">{t("config.operation-hours.operating-day")}</label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <TimePicker time={settings.Saturday_start} onChange={(value) => setSettings({ ...settings, Saturday_start: value })} disable={!settings.Saturday_status} />
                                                        </td>
                                                        <td>
                                                            <TimePicker time={settings.Saturday_end} onChange={(value) => setSettings({ ...settings, Saturday_end: value })} disable={!settings.Saturday_status} />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>{t("config.operation-hours.sunday")}</td>
                                                        <td>
                                                            <div className="form-check form-switch ">
                                                                <input type="checkbox" className="form-check-input" id="Sunday_status" checked={settings.Sunday_status} onChange={({ target: { checked } }) => handleDayOff('Sunday_status', checked)} />
                                                                <label className="form-check-label" htmlFor="Sunday_status">{t("config.operation-hours.operating-day")}</label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <TimePicker time={settings.Sunday_start} onChange={(value) => setSettings({ ...settings, Sunday_start: value })} disable={!settings.Sunday_status} />
                                                        </td>
                                                        <td>
                                                            <TimePicker time={settings.Sunday_end} onChange={(value) => setSettings({ ...settings, Sunday_end: value })} disable={!settings.Sunday_status} />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="text-end">
                                            <Button type="submit" className="btn btn-primary btn-sm" isLoading={false} onClick={saveHours}>{t("config.operation-hours.save-btn")}</Button>
                                        </div>
                                    </div>

                                </div>

                                <hr />

                                <div className="row ">
                                    <div className="col-4">
                                        <div className="text-center">
                                            <img src="/assets/img/ad-block.png" className=" d-block m-auto mb-3" style={{ height: '100px' }} />
                                            <div className="mb-3">
                                                {
                                                    settings.limited_connection ? (
                                                        <span className="badge bg-soft-info text-info">
                                                            <span className="legend-indicator bg-info"></span> {t("config.operation-hours.active")}
                                                        </span>
                                                    ) : (
                                                        <span className="badge bg-soft-danger text-danger">
                                                            <span className="legend-indicator bg-danger"></span> {t("config.operation-hours.inactive")}
                                                        </span>
                                                    )
                                                }
                                            </div>

                                            <p>{t("config.operation-hours.limit-sessions-p")}</p>

                                            <button className={`btn btn-sm btn-${settings.limited_connection ? 'outline-primary' : 'primary'}`} onClick={() => saveSettingsSession('limited_connection')}>{settings.limited_connection ? t("config.operation-hours.disable") : t("config.operation-hours.enable")}</button>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="text-center">
                                            <img src="/assets/img/seller.png" className=" d-block m-auto mb-3" style={{ height: '100px' }} />

                                            <div className="mb-3">
                                                {
                                                    settings.limited_asignation ? (
                                                        <span className="badge bg-soft-info text-info">
                                                            <span className="legend-indicator bg-info"></span> {t("config.operation-hours.active")}
                                                        </span>
                                                    ) : (
                                                        <span className="badge bg-soft-danger text-danger">
                                                            <span className="legend-indicator bg-danger"></span> {t("config.operation-hours.inactive")}
                                                        </span>
                                                    )
                                                }
                                            </div>

                                            <p>{t("config.operation-hours.limit-p")}</p>

                                            <button className={`btn btn-sm btn-${settings.limited_asignation ? 'outline-primary' : 'primary'}`} onClick={() => saveSettingsSession('limited_asignation')} >{settings.limited_asignation ? t("config.operation-hours.disable") : t("config.operation-hours.enable")}</button>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="text-center">
                                            <img src="/assets/img/send.png" className=" d-block m-auto mb-3" style={{ height: '100px' }} />
                                            <div className="mb-3">
                                                {
                                                    settings.automatic_messages ? (
                                                        <span className="badge bg-soft-info text-info">
                                                            <span className="legend-indicator bg-info"></span> {t("config.operation-hours.active")}
                                                        </span>
                                                    ) : (
                                                        <span className="badge bg-soft-danger text-danger">
                                                            <span className="legend-indicator bg-danger"></span> {t("config.operation-hours.inactive")}
                                                        </span>
                                                    )
                                                }
                                            </div>

                                            <p>{t("config.operation-hours.activate-p")}</p>

                                            <button className={`btn btn-sm btn-${settings.automatic_messages ? 'outline-primary' : 'primary'}`} onClick={() => saveSettingsSession('automatic_messages')} >{settings.automatic_messages ? t("config.operation-hours.disable") : t("config.operation-hours.enable")}</button>
                                        </div>
                                    </div>
                                </div>
                                </>
                            }
                            </div>
                        </div>
            </div>
        </>
    )
}
export default OfficeHoursPartial